/* eslint-disable */

import React from 'react'
import { Box } from '@mui/material'

interface ColorwayDotProps {
  colors: string[]
  size?: number
  title?: string
  variant?: 'stripes' | 'pie'
}

/** Renders a dot with multiple colors as stripes or pie chart */
export default function ColorwayDot({ colors, size = 16, title, variant = 'pie' }: ColorwayDotProps) {
  const safeColors = colors.filter(Boolean).length > 0 ? colors.filter(Boolean) : ['#000000']

  if (safeColors.length === 1) {
    return (
      <Box
        title={title}
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: safeColors[0],
          border: '1px solid',
          borderColor: 'divider',
          flexShrink: 0
        }}
      />
    )
  }

  if (variant === 'stripes') {
    const stripeStops = safeColors
      .map((c, i) => `${c} ${(i / safeColors.length) * 100}% ${((i + 1) / safeColors.length) * 100}%`)
      .join(', ')
    return (
      <Box
        title={title}
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: `linear-gradient(90deg, ${stripeStops})`,
          border: '1px solid',
          borderColor: 'divider',
          flexShrink: 0
        }}
      />
    )
  }

  // Pie chart: conic-gradient
  const conicStops = safeColors
    .map((c, i) => {
      const start = (i / safeColors.length) * 360
      const end = ((i + 1) / safeColors.length) * 360
      return `${c} ${start}deg ${end}deg`
    })
    .join(', ')

  return (
    <Box
      title={title}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `conic-gradient(${conicStops})`,
        border: '1px solid',
        borderColor: 'divider',
        flexShrink: 0
      }}
    />
  )
}
